import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const propTypes = {
  value: PropTypes.number.isRequired,
  displayType: PropTypes.string
};

const defaultProps = {
  displayType: 'text'
};

function PhoneNumber({ value, displayType }) {
  return (
    <a href={`tel:1${value}`}>
      <NumberFormat
        format="(###) ###-####"
        value={value}
        displayType={displayType}
      />
    </a>
  );
}

PhoneNumber.propTypes = propTypes;
PhoneNumber.defaultProps = defaultProps;

export default PhoneNumber;
